import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import ChevronIcon from 'components/icons/ChevronIcon';
import LocalizedLink from 'components/LocalizedLink';
import Paragraph from 'components/Paragraph';
import Strong from 'components/Strong';
import React from 'react';

const CSS = require('./BookingTransferred.less');

type BookingTransferredProps = {
  bookingId: string;
  oldHostName: string;
};

function BookingTransferred({ bookingId, oldHostName }: BookingTransferredProps) {
  return (
    <div className={CSS.BookingTransferred}>
      <div className={CSS.SuccessIcon}>
        <CheckmarkIcon className={CSS.Checkmark} />
      </div>
      <h1 className={CSS.Title}>
        The transfer has been successfully added to your bookings!
      </h1>
      <Paragraph className={CSS.Paragraph}>
        <Strong weight="medium">Thanks for your collaboration! <span role="img" aria-label="heart emoji">💖</span></Strong>&nbsp;
        You can now contact the guest and introduce yourself to make sure you will have a great experience together!
      </Paragraph>
      <LocalizedLink className={CSS.Link} to={`/bookings/${bookingId}/`}>View booking <ChevronIcon direction="right" /></LocalizedLink>
      <Paragraph className={CSS.Paragraph}>
        We have also let <Strong>{oldHostName}</Strong> know that the booking has been transferred to you.
      </Paragraph>
    </div>
  );
}

export default BookingTransferred;
